import { useState, useRef, useEffect } from "react";
import axios from "axios";
import { useOutletContext } from "react-router-dom";

export default function SpeechToText({
  extractedText,
  textchange,
  jdtext,
  onTextChange,
}) {
  const [text, setText] = useState("");
  const [recording, setRecording] = useState(false);
  const [processing, setProcessing] = useState(false);

  const mediaRecorderRef = useRef(null);
  const audioChunksRef = useRef([]);

  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const { setGlobalLoading, token } = useOutletContext();

  const timeoutRef = useRef(null);

  const startRecording = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({
        audio: true,
      });

      const mediaRecorder = new MediaRecorder(stream);

      audioChunksRef.current = [];

      mediaRecorder.ondataavailable = (event) => {
        audioChunksRef.current.push(event.data);
      };

      mediaRecorder.onstop = async () => {
        setProcessing(true);

        const audioBlob = new Blob(audioChunksRef.current, {
          type: mediaRecorder.mimeType,
        });

        const extensionMap = {
          "audio/webm": "webm",
          "audio/mp4": "mp4",
          "audio/mpeg": "mp3",
          "audio/ogg": "ogg",
        };

        const cleanMimeType = mediaRecorder.mimeType.split(";")[0];

        const extension = extensionMap[cleanMimeType] || "webm";

        const formData = new FormData();

        console.log("mimeType:", mediaRecorder.mimeType);
        console.log("blob type:", audioBlob.type);

        formData.append(
          "audio",
          audioBlob,
          `recording-${Date.now()}.${extension}`,
        );

        try {
          const response = await axios.post(
            `${API_BASE_URL}/candidates/transcribe_jd`,
            formData,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            },
          );

          setText((prev) =>
            prev ? prev + " " + response.data.text : response.data.text,
          );
        } catch (err) {
          console.error(err.response?.data || err.message);
          alert("Transcription failed");
        }

        setProcessing(false);

        stream.getTracks().forEach((track) => track.stop());
      };

      mediaRecorder.start(1000);

      mediaRecorderRef.current = mediaRecorder;

      setRecording(true);

      timeoutRef.current = setTimeout(() => {
        if (mediaRecorderRef.current?.state === "recording") {
          stopRecording();
        }
      }, 30000);
    } catch (error) {
      console.error(error);
      alert("Microphone permission denied");
    }
  };

  const stopRecording = () => {
    clearTimeout(timeoutRef.current);

    if (
      mediaRecorderRef.current &&
      mediaRecorderRef.current.state === "recording"
    ) {
      mediaRecorderRef.current.stop();
    }

    setRecording(false);
  };

  // useEffect(() => {
  //   if (text.trim() === "") {
  //     return;
  //   }
  //   textchange(text);
  // }, [text]);

  const lastEmittedText = useRef("");

  useEffect(() => {
    // Only sync an incoming jdtext prop when it's a genuinely EXTERNAL
    // change (e.g. the summary got written into the parent after a
    // search) — not an echo of the value this component itself just
    // emitted via onTextChange, which would otherwise create a
    // feedback loop that fights the user's own typing.
    if (jdtext && jdtext !== lastEmittedText.current) {
      setText(jdtext);
    }
  }, [jdtext]);

  useEffect(() => {
    lastEmittedText.current = text;
    onTextChange?.(text);
  }, [text]);

  return (
    <div className="position-relative">
      <textarea
        className="form-control"
        rows={4}
        value={text}
        onChange={(e) => setText(e.target.value)}
        placeholder="eg. We're looking for a VP of Engineering with 15+ years of hands-on experience in Python, Django, and PostgreSQL. (Min. 10 Words)"
      />
      <span
        className="position-absolute top-0 text-muted opocity-50"
        style={{ right: 5 }}
      >
        {text.length > 0 ? text.length : ""}
      </span>
      <div
        className="position-absolute d-flex"
        style={{ bottom: "10px", right: "10px" }}
      >
        <button
          type="button"
          className={`btn ${recording ? "btn-danger" : "btn-primary"} mic-btn d-flex justify-content-center`}
          onClick={recording ? stopRecording : startRecording}
          disabled={processing}
          title={recording ? "Stop Recording" : "Start Recording"}
        >
          {processing ? (
            <i className="fa fa-spinner fa-spin" />
          ) : recording ? (
            <i className="fa fa-stop" />
          ) : (
            <i className="fa fa-microphone" />
          )}
        </button>
      </div>
    </div>
  );
}
